import {baseRoute} from '../../../constants/routes';

export const STATISTICS_QUIZ_ROUTE = baseRoute + '/statistics/quiz';
export const STATISTICS_QUIZ_SUCCESS = 'STATISTICS_QUIZ_SUCCESS';

export const DOWNLOAD_QUIZ_STATISTICS_ROUTE = baseRoute + '/export/QuizLocalization';
export const DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE = 'DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE';
export const DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE_SUCCESS = 'DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE_SUCCESS';